/**
 * Get Bounded Context Query
 * 
 * Query for retrieving bounded context information for read operations.
 */

import { IQuery, BaseQuery, IPaginatedResult } from '@swoft/core';

export interface BoundedContextDto {
  id: string;
  boundedContextId: string;
  domainId: string;
  domainName?: string; // Domain name resolved from domain aggregate
  name: string;
  description?: string;
  type: string;
  ubiquitousLanguage: Record<string, string>;
  domainServices: any[];
  aggregates: any[];
  valueObjects: any[];
  entities: any[];
  createdAt: Date;
  updatedAt: Date;
}

export class GetBoundedContextQuery extends BaseQuery<BoundedContextDto> {
  constructor(
    public readonly domainId: string,
    public readonly contextId: string,
    authSessionId: string,
    initiatedByPersonId: string,
    correlationId?: string
  ) {
    super(authSessionId, initiatedByPersonId, correlationId);
  }
}

export interface ListBoundedContextsParams {
  page?: number;
  pageSize?: number;
  domainId?: string;
  type?: 'core' | 'supporting' | 'generic';
  searchTerm?: string;
}

export class ListBoundedContextsQuery extends BaseQuery<IPaginatedResult<BoundedContextDto>> {
  constructor(
    public readonly params: ListBoundedContextsParams,
    authSessionId: string = 'system',
    initiatedByPersonId: string = 'system',
    correlationId?: string
  ) {
    super(authSessionId, initiatedByPersonId, correlationId);
  }
}